import styled from "styled-components";

export const NotificationContainer = styled.div`
    box-sizing: border-box;
    max-height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 8px;
    position: fixed;
    z-index: 1000;
    top: 60px;
    right: 0;
`;
